import React from 'react';
import { Grid } from 'src/design/atoms/Grid';
import { useNavigate } from 'react-router-dom';
import { WorkTicketDto } from 'src/api/FiretrolApiClient';
import { Header } from 'src/design/organisms/Header';
import { useAuth } from 'src/hooks/useAuth';
import { useJobs } from 'src/hooks/useJobs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { WorkTicketForm } from 'src/routes/Jobs/Tickets/WorkTicketForm';

export const CreateTicket: React.FC = () => {
  const { selectedJob } = useJobs();
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!selectedJob || !user) return null;
  const initialValues: WorkTicketDto = {
    id: '00000000-0000-0000-0000-000000000000',
    createdById: user.id,
    useSignaturePad: false,
    date: new Date(),
    summary: '',
    signatureString: '',
    requester: '',
    signature: '[]',
    status: 'Created',
    rateRequests: [],
    jobId: selectedJob.id,
    attachment: [],
    attachmentsToAdd: [],
    attachmentsToRemove: [],
  };
  return (
    <>
      <Header
        title="Create"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            {
              text: 'Work Tickets',
              href: `/jobs/${selectedJob.id}/tickets`,
            },
            { text: 'Create' },
          ],
        }}
        helpText="Create a new work ticket for this job."
      />
      <Grid>
        <Grid.Col>
          <WorkTicketForm
            jobId={selectedJob.id}
            initialValues={initialValues}
            sideCancelButton={
              <SecondaryButton
                fullWidth
                className="m-b-15"
                onClick={() => navigate(`/jobs/${selectedJob.id}/tickets`)}
              >
                Cancel
              </SecondaryButton>
            }
            cancelButton={
              <SecondaryButton
                className="m-r-10"
                onClick={() => navigate(`/jobs/${selectedJob.id}/tickets`)}
              >
                Cancel
              </SecondaryButton>
            }
          />
        </Grid.Col>
      </Grid>
    </>
  );
};
